import { Component, Inject, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InOrdersDataSourceService } from 'src/app/core/data-sources/v3/in-orders/in-orders-data-source.service';
import { InOrder } from 'src/models/InOrder';

@Component({
  selector: 'app-in-details',
  templateUrl: './in-details-buy-order-modal.component.html',
  styleUrls: ['./in-details-buy-order-modal.component.scss']
})
export class InDetailsBuyOrderModalComponent implements OnInit, OnDestroy {
  @Output() itemClick = new EventEmitter();
  titleModal: string;

  constructor(
    public dialogRef: MatDialogRef<InDetailsBuyOrderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public order: InOrder,
    private inOrdersDataSourceService: InOrdersDataSourceService
  ) { }

  ngOnInit(): void {
    this.titleModal = `Ordem de Entrada N° ${this.order.orderNumber}`;
    this.inOrdersDataSourceService.getInOrderDetails(this.order.id).then((data: InOrder) => {
      this.order = data;
    });
  }

  ngOnDestroy() {
    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
